import React, { useMemo } from 'react';
import styled from 'styled-components';
import useArrayManagement from '@ubeya/shared-web/hooks/useArrayManagement';
import { ReactComponent as Close } from '@ubeya/shared-web/assets/close-big.svg';
import { ReactComponent as Star } from '@ubeya/shared-web/assets/star.svg';
import { ReactComponent as StarFill } from '@ubeya/shared-web/assets/star-filled-primary.svg';
import { getSource } from '@ubeya/shared-web/utils/files';
import { CircleIcon, PromptClick } from '@ubeya/shared-web/components';

const CloseIcon = styled(CircleIcon)`
  position: absolute;
  right: 3px;
  top: 3px;
  width: 20px;
  height: 20px;
  padding: 6px;
  display: none;
`;

const ShareIcon = styled(CircleIcon)`
  position: absolute;
  right: 20px;
  top: 3px;
  width: 20px;
  height: 20px;
  padding: 6px;
  display: flex;
`;

const Wrapper = styled.div`
  position: relative;
  margin: 0 30px 30px 0;
  &:hover {
    ${CloseIcon} {
      display: flex;
    }
  }
`;

const Image = styled.div.attrs(({ src }) => ({ style: { backgroundImage: `url(${src})` } }))`
  width: 100px;
  height: 100px;
  background-position: center;
  background-size: cover;
  position: relative;
  cursor: pointer;
`;

const Photo = ({ t, item, onClick, updateEmployeePhoto }) => {
  const { handleDelete } = useArrayManagement('photos');

  const source = useMemo(() => getSource(item), [item]);

  return (
    <Wrapper>
      <Image src={source} onClick={onClick} />

      <PromptClick
        onClick={() => handleDelete(item)}
        body="areYouSureYouWantToDelete"
        confirmText="delete"
        stopPropagation>
        <CloseIcon icon={Close} />
      </PromptClick>

      <PromptClick
        onClick={() =>
          updateEmployeePhoto({ employeePhotoId: item.employeePhotoId, isSharedWithClient: !item.isSharedWithClient })
        }
        body={item?.isSharedWithClient ? 'areYouSureYouWantToUnstarPhoto' : 'areYouSureYouWantToStarPhoto'}
        confirmText="ok"
        stopPropagation>
        <ShareIcon
          icon={item?.isSharedWithClient ? StarFill : Star}
          tooltip={item?.isSharedWithClient ? t('photoSharedWithClient') : t('photoNotSharedWithClient')}
        />
      </PromptClick>
    </Wrapper>
  );
};

export default Photo;
